import * as angular from 'angular';

angular.module('web-manage-my-booking-templates', []).run(['$templateCache', ($templateCache) => {

    function requireAll (requireContext) {
        return requireContext.keys().map(val => {
            return {
                tpl: requireContext(val), // tpl will hold the value of your html string
                name: `web-manage-my-booking/templates/${val.split('/').pop()}` //name is just the filename
            };
        });
    }

    let modules = requireAll(
        import.meta.webpackContext(
            './app',
            { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-booking-dashboard/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-bookings-list/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-change-flight/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-flight-confirmation/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-on-hold-confirmation/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-passengers-info/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-Mmb-rebook-error/assets',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-on-hold-anulation',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-booking-management',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-communication-lost',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-flexibilization',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-search',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-disruption-main/assests',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-reusable-components',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-commons/dist',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-menus/dist',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-payments/dist',
                { recursive: true, regExp: /ib-pmt-view\.html/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-payments/dist',
                { recursive: true, regExp: /ib-pmt-mmb-confirmation-view\.html/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-payments/dist',
                { recursive: true, regExp: /ib-pmt-order-confirmation-view\.html/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-payments/dist',
                { recursive: true, regExp: /ib-pmt-communication-lost-view\.html/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-gastronomic-proposal',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-voluntary-refunds',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                './components/ib-MmB-ancillaries-page',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );

    modules.forEach(val => {
        $templateCache.put(val.name, val.tpl);
    });
}]);
